import {Routes} from '@angular/router';
import {TipoProfilo} from '../../shared/models';
import {AuthGuard} from '../../core/guards';

export const configurazioneRoutes: Routes = [
	/*{
		path: 'configurazione/apps',
		loadComponent: () => import('./applicazioni/applicazioni.component').then(c => c.ApplicazioniComponent),
		canActivate: [AuthGuard],
		data: {authorities: [TipoProfilo.ADMIN]}
	},
	{
		path: 'configurazione/functions',
		loadComponent: () => import('./funzioni/funzioni.component').then(c => c.FunzioniComponent),
		canActivate: [AuthGuard],
		data: {authorities: [TipoProfilo.ADMIN]}
	},*/
	{
		path: 'configurazione/users',
		loadComponent: () => import('./utenti/utenti.component').then(c => c.UtentiComponent),
		canActivate: [AuthGuard],
		data: {authorities: [TipoProfilo.ADMIN, TipoProfilo.RESPONSABILE]}
	},
	{
		path: 'configurazione/licenze-log',
		loadComponent: () => import('./licenze-log/licenze-log.component').then(c => c.LicenzeLogComponent),
		canActivate: [AuthGuard],
		data: {authorities: [TipoProfilo.ADMIN]}
	},
	{
		path: 'configurazione/companies',
		loadComponent: () => import('./aziende/aziende.component').then(c => c.AziendeComponent),
		canActivate: [AuthGuard],
		data: {authorities: [TipoProfilo.ADMIN, TipoProfilo.RESPONSABILE]}
	}
];
